"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("@common/models/Client"));
const Role_1 = __importDefault(require("@common/models/Role"));
const Permission_1 = __importDefault(require("@common/models/Permission"));
class User {
    constructor(id, name, email, client, created_at, updated_at, isBmk, avatar, isITMember = false, roles = [], permissions = []) {
        this.id = id;
        this.avatar = avatar;
        this.name = name;
        this.email = email;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.isBmk = isBmk;
        this.isITMember = isITMember;
        this.client = client;
        this.roles = roles;
        this.permissions = permissions;
        this.is_super_admin = this.hasRole(Role_1.default.SUPER_ADMIN_ROLE);
    }
    static fromJson(json) {
        var _a, _b;
        return new User(json.id, json.name, json.email, Client_1.default.fromJson(json.client), json.created_at, json.updated_at, json.biome_level > 0 && json.role === 1, json.avatar, json.it_level > 0, (_a = json.roles) === null || _a === void 0 ? void 0 : _a.map((role) => new Role_1.default(role)), (_b = json.permissions) === null || _b === void 0 ? void 0 : _b.map((permission) => new Permission_1.default(permission)));
    }
    hasRole(role) {
        return !!this.roles.some(userRoles => userRoles.name === role);
    }
    hasPermissionTo(permission) {
        if (this.is_super_admin) {
            return true;
        }
        return !!this.permissions.some(userPermission => userPermission.name === permission);
    }
    can(permission) {
        return this.hasPermissionTo(permission);
    }
}
exports.default = User;
